
export const createBatchAtomicPayLoad = (addOperations: any[], updateOperations: any[], deleteOperations: any[]) => {
    return {
        "atomic:operations": [
            ...addOperations,
            ...updateOperations,
            ...deleteOperations
        ]
    }
}

export const ATOMIC_CONTENT_TYPE = 'application/vnd.api+json; ext="https://jsonapi.org/ext/atomic"';
